import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TemaService } from './core/services/tema.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('PlataCheck');
  // Inyectar aquí garantiza que TemaService se inicialice en todas las rutas (login, setup, etc.)
  protected readonly _tema = inject(TemaService);
}
